export const environment = {
  production: true,
  ambiente: 'produção',
  wsUrl: 'https://ws.unionsolutions.com.br/',
  homeUrl: 'https://sistema.unionsolutions.com.br',
  gaMeasurementId: ''
};
